import Button from "@components/core/Button";
import classNames from "classnames";

function LikeButton({ liked, onClick, className }) {
  return (
    <Button
      trackingName={liked ? "HeartRemoveFromWishlist" : "HeartAddToWishlist"}
      variant={liked ? "primary" : "outline-primary"}
      size="sm"
      leftIconName="heart-empty"
      onClick={onClick}
      className={classNames("rounded-circle border-none", className)}
    />
  );
}

export default LikeButton;
